import { Spinner } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidacies } from '../../../../commons/redux/actions/user.actions'
import ItemPartenaireDemand from './item_partenaire'

export default function PartenaireDemand() {
  const { item } = useSelector((state) => state.adminReducer)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getCandidacies())
  }, [dispatch])

  return (
    <>
      <div className="col-lg-8 bg-white mx-auto  mt-5">
        <div className="flex mx-auto font-bold text-3xl text-center">
          <h2>Candidatures</h2>
          <p className="w-9 h-8 rounded-full text-xl m-2 text-orange-300 bg-gray-600">
            {item?.length > 0 ? item.length : 0}
          </p>
          <hr />
        </div>
        <div className="flex flex-wrap">
          {!item ? (
            <div className="text-center mx-auto">
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
              />
            </div>
          ) : item && item?.length > 0 ? (
            <>
              {Array.from(item)?.map((value, index) => {
                return <ItemPartenaireDemand {...value} />
              })}
            </>
          ) : (
            <div>
              <h3 className="text-3xl font-bold opacity-50 text-red-500 text-center">
                Aucune nouvelle demande
              </h3>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
